<template>
<div :style="scaleStyle"
     ref="previewMain"
     :class="{
       'is-sample': isSample,
       'is-preview': !isSample,
       'is-mini': isMini
     }">
  <div class="doc-paper preview rirekisho"
       :id="idPrefix + 'preview-page-01'">
    <div class="flex">
      <div class="rirekisho-box1">
        <div class="rirekisho-header">
          <div class="title">履歴書</div>
          <div class="date"
               @click="goCardTo('create-date')"
               :class="highLightClass('create-date')">
            <span v-html="formatedCreateDate"></span> 現在
          </div>
        </div>
        <div class="rirekisho-profile"
             :data-highlight="highlightMessage"
             @click="goCardTo('profile')"
             :class="highLightClass('profile')">
          <div class="ruby flex">
            <div class="label">ふりがな</div>
            <div class="input" :style="formatData.selFontStyle">{{ basicData.lastNameFurigana }}&emsp;{{ basicData.firstNameFurigana }}</div>
          </div>
          <div class="name flex">
            <div class="label">名前</div>
            <div class="input" :style="formatData.selFontStyle">{{ basicData.lastName }}&emsp;{{ basicData.firstName }}</div>
          </div>
          <div class="etc flex">
            <div class="birthday" :style="formatData.selFontStyle">
              <span class="year">{{ basicData.birthYear }}</span>年 <span class="month">{{ basicData.birthMonth }}</span>月 <span class="day">{{ basicData.birthDay }}</span>日生（満 <span class="age">{{ age }}</span> 歳）
            </div>

            <div class="gender">
              <span class="male" v-if="!isGenderDisplay"
                    v-bind:class="{'preview-is-checked': isMale}">男</span><span v-if="!isGenderDisplay">・</span>
              <span class="female" v-if="!isGenderDisplay"
                    v-bind:class="{'preview-is-checked': isFemale}">女</span>
            </div>
          </div>
        </div>
      </div>
      <div class="rirekisho-photo"
           :data-highlight="highlightMessage"
           @click="goCardTo('id-photo')"
           :class="highLightClass('id-photo')">
        <div v-if="basicData.idPhotoSrc">
          <img :src="basicData.idPhotoSrc"
               alt="証明写真">
        </div>
        <div v-else>
          <div class="rirekisho-photo-inner">
            <p>証明写真
              <br>縦 36mm&#12316;40mm
              <br>横 24mm&#12316;30mm
              <br>本人単身胸から上
              <br>裏面のりづけ
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="rirekisho-box2">
      <div class="contact-information contact-main flex">
        <div class="contact-information-address"
             :data-highlight="highlightMessage"
             @click="goCardTo('address')"
             :class="highLightClass('address')">
          <div class="ruby flex">
            <div class="label">ふりがな</div>
            <div class="input" ref="addressFurigana"
                 :class="classObject.addressFurigana" :style="formatData.selFontStyle">{{ basicData.addressFurigana }}</div>
          </div>
          <div class="address flex">
            <div class="label">現住所</div>
            <div class="input">
              <div class="postal-code" :style="formatData.selFontStyle">&#12306;{{ $formLib.separatedPostNumber(basicData.postNumber) }}</div>
              <pre :style="formatData.selFontStyle">{{ basicData.address1}}
{{ basicData.address2 }}</pre>
            </div>
          </div>
        </div>
        <div class="contact-information-etc"
             :data-highlight="highlightMessage"
             @click="goCardTo('contacts')"
             :class="highLightClass('contacts')">
          <div class="tel flex">
            <div class="label">電話</div>
            <div class="input" :style="formatData.selFontStyle">{{ tel }}</div>
          </div>
          <div class="email flex">
            <div class="label">Email</div>
            <div class="input" :style="formatData.selFontStyle">{{ basicData.email }}</div>
          </div>
        </div>
      </div>
      <div class="contact-information contact-sub flex">
        <div class="contact-information-address"
             @click="goCardTo('address')"
             :class="highLightClass('address')">
          <div class="ruby flex">
            <div class="label">ふりがな</div>
            <div class="input"
                 :class="{'font-size-sm': ($formLib.charCount(basicData.contactAddressFurigana) > 59) }" :style="formatData.selFontStyle">{{ basicData.contactAddressFurigana }}</div>
          </div>
          <div class="address flex">
            <div class="label">連絡先</div>
            <div class="input">
              <div class="postal-code" :style="formatData.selFontStyle">&#12306;{{ $formLib.separatedPostNumber(basicData.contactPostNumber) }}</div>
              <div class="comment">(現住所以外に連絡を希望する場合のみ入力)</div>
              <pre :style="formatData.selFontStyle">{{ basicData.contactAddress1 }}
{{ basicData.contactAddress2 }}</pre>
              <div class="care-of"
                   v-if="basicData.contactCareOf" :style="formatData.selFontStyle">{{ basicData.contactCareOf }} 方</div>
            </div>
          </div>
        </div>
        <div class="contact-information-etc"
             @click="goCardTo('contacts')"
             :class="highLightClass('contacts')">
          <div class="tel flex">
            <div class="label">電話</div>
            <div class="input" :style="formatData.selFontStyle">{{ contactTel }}</div>
          </div>
          <div class="email flex">
            <div class="label">Email</div>
            <div class="input" :style="formatData.selFontStyle">{{ basicData.contactEmail }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="rirekisho-table rirekisho-history-1"
         :data-highlight="highlightMessage"
         @click="goCardTo('edu-history')"
         :class="highLightClass(['edu-history','job-history'])">
      <table :class="{error:this.errorMessages.eduJobHistory}">
        <thead>
          <tr>
            <th>年</th>
            <td>月</td>
            <td>学歴・職歴</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in eduJobHistoryTable"
              v-bind:class="item.classObject"
              v-if="index < 16"
              :key="index">
            <th :style="formatData.selFontStyle">{{ item.year }}</th>
            <td :style="formatData.selFontStyle">{{ item.month }}</td>
            <td :class="{'font-size-sm': ($formLib.charCount(item.description) > 68) }" :style="formatData.selFontStyle">{{ item.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div v-if="!isMini"
     class="doc-paper preview rirekisho"
     :id="idPrefix + 'preview-page-02'">
    <div class="rirekisho-table rirekisho-history-2"
         @click="goCardTo('edu-history')"
         :class="highLightClass(['edu-history','job-history'])">
      <table :class="{error:this.errorMessages.eduJobHistory}">
        <thead>
          <tr>
            <th>年</th>
            <td>月</td>
            <td>学歴・職歴</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in eduJobHistoryTable"
              v-bind:class="item.classObject"
              v-if="index > 15 && index < 22"
              :key="index">
            <th :style="formatData.selFontStyle">{{ item.year }}</th>
            <td :style="formatData.selFontStyle">{{ item.month }}</td>
            <td :class="{'font-size-sm': ($formLib.charCount(item.description) > 68) }" :style="formatData.selFontStyle">{{ item.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="rirekisho-table rirekisho-skill"
         :data-highlight="highlightMessage"
         @click="goCardTo('license-history')"
         :class="highLightClass('license-history')">
      <table :class="{error:this.errorMessages.licenseHistory}">
        <thead>
          <tr>
            <th>年</th>
            <td>月</td>
            <td>免許・資格</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in licenseHistoryTable"
              v-bind:class="item.classObject"
              v-if="index < 6"
              :key="index">
            <th :style="formatData.selFontStyle">{{ item.year }}</th>
            <td :style="formatData.selFontStyle">{{ item.month }}</td>
            <td :class="{'font-size-sm': ($formLib.charCount(item.description) > 68) }" :style="formatData.selFontStyle">{{ item.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="rirekisho-pr">
      <div class="rirekisho-pr-reason"
           v-if="formatId != 'rirekisho_job_change'"
           :data-highlight="highlightMessage"
           @click="goCardTo('reason')"
           :class="highLightClass('reason')">
        <div class="label">志望動機・特技・アピールポイントなど</div>
        <div class="input">
          <pre ref="reason"
               :class="classObject.reason" :style="formatData.selFontStyle">{{ formatData.reason }}</pre>
        </div>
      </div>
      <div class="rirekisho-jis-pr-reason"
            v-else
           :data-highlight="highlightMessage"
           @click="goCardTo('reason')"
           :class="highLightClass('reason')">
        <div class="label">志望動機・特技・アピールポイントなど</div>
        <div class="input">
          <pre ref="reason"
               :class="classObject.reason" :style="formatData.selFontStyle">{{ formatData.reason }}</pre>
        </div>
      </div>
      <div class="rirekisho-pr-etc"
            v-if="formatId != 'rirekisho_job_change'"
           :data-highlight="highlightMessage"
           @click="goCardTo('others')"
           :class="highLightClass('others')">
        <div class="time">
          <div class="label">通勤時間</div>
          <div class="input"
               :class="{error: $formLib.charCount(formatData.commuteDescription) > this.textMaxLength['commuteDescription']}" :style="formatData.selFontStyle">{{ formatData.commuteDescription }}</div>
          <div class="input" v-if="formatData.commuteHours || formatData.commuteMinutes" :style="formatData.selFontStyle">約 <template v-if="formatData.commuteHours"><span>{{ formatData.commuteHours }}</span> 時間</template> <template v-if="formatData.commuteMinutes"><span>{{ formatData.commuteMinutes }}</span> 分</template></div>
        </div>
        <div class="family">
          <div class="label">扶養家族数（配偶者を除く）</div>
          <div class="input"><span :style="formatData.selFontStyle">{{ formatData.spouseNumber }}</span> 人</div>
        </div>
        <div class="partner">
          <div class="existence">
            <div class="label">配偶者</div>
            <div class="input">
              <span class="yes"
                    :class="{'preview-is-checked': formatData.hasSpouse}">有</span> ・
              <span class="no"
                    :class="{'preview-is-checked': !formatData.hasSpouse}">無</span></div>
          </div>
          <div class="support">
            <div class="label">配偶者の扶養義務</div>
            <div class="input">
              <span class="yes"
                    :class="{'preview-is-checked':formatData.underDutyToSupport }">有</span> ・
              <span class="no"
                    :class="{'preview-is-checked':!formatData.underDutyToSupport }">無</span></div>

          </div>
        </div>
      </div>
    </div>
    <div class="rirekisho-hope"
         :data-highlight="highlightMessage"
         @click="goCardTo('requests')"
         :class="highLightClass('requests')">
      <div class="label">本人希望欄（特に給料・職種・勤務時間・勤務地・その他について希望があれば記入）</div>
      <div class="input">
        <pre ref="request"
             :class="classObject.request" :style="formatData.selFontStyle">{{ formatData.request }}</pre>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import RirekishoPreviewMixin from '@/mixins/rirekisho-preview-mixin'
export default {
  name: 'rirekishoPreview',
  props: {
    formatId: {
      type: String
    },
    isMini: {
      type: Boolean,
      default: false
    }
  },
  mixins: [RirekishoPreviewMixin],
  data: function () {
    return {
      maxEduJobRows: 22,
      maxLicenseRows: 6,
      textareaMaxHeights: {
        reason: 175,
        request: 180
      }
    }
  },
  methods: {
    checkValid: function () {
      this.adjustFontSize('reason')
      this.adjustFontSize('reasonNew')
      this.adjustFontSize('request')
      this.adjustFontSize('addressFurigana')
    }
  },
  watch: {
    formatData: function () {
      this.checkValid()
    }
  }
}
</script>
<style>
.preview.rirekisho {
  margin: 0 auto;
}

.is-mini .preview.rirekisho {
  margin: 0;
  box-shadow: none;
}
</style>
